import { useQueryClient } from '@tribeplatform/react-sdk/lib';
import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getTemplatesKey } from '../../utils/keys';
export const useUnpublishTemplate = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.mutation({
        name: 'unpublishTemplate',
        args: {
            fields,
            variables,
        },
    }), {
        onSettled: () => {
            queryClient.invalidateQueries(getTemplatesKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUnpublishTemplate.js.map